import { render, staticRenderFns } from "./ConnectionMethodBadge.vue?vue&type=template&id=57bde300&scoped=true"
import script from "./ConnectionMethodBadge.vue?vue&type=script&lang=js"
export * from "./ConnectionMethodBadge.vue?vue&type=script&lang=js"
import style0 from "./ConnectionMethodBadge.vue?vue&type=style&index=0&id=57bde300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bde300",
  null
  
)

export default component.exports